var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SectionTransformTable', [_vm.isShowSidebar ? _c('SidebarClient', {
    attrs: {
      "data": _vm.detailTravelAgentData,
      "isShow": _vm.isShowSidebar
    },
    on: {
      "update:isShow": function ($event) {
        _vm.isShowSidebar = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowSidebar = $event;
      }
    }
  }) : _vm._e(), _c('SearchList', {
    attrs: {
      "title": "ar_client_travel_agent_list"
    },
    on: {
      "search": _vm.refetchData
    }
  }, [_c('FormItems', {
    attrs: {
      "formData": _vm.searchVal,
      "items": _vm.formItems
    },
    on: {
      "update:formData": function ($event) {
        _vm.searchVal = $event;
      },
      "update:form-data": function ($event) {
        _vm.searchVal = $event;
      }
    }
  })], 1), _vm.isShowModal ? _c('ModalClient', {
    attrs: {
      "is-show": _vm.isShowModal
    },
    on: {
      "refetch": _vm.refetchData,
      "update:isShow": function ($event) {
        _vm.isShowModal = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowModal = $event;
      }
    }
  }) : _vm._e(), _c('b-card', [_c('EzTable', {
    ref: "tableRef",
    attrs: {
      "dataSourceParams": _vm.searchVal,
      "excel-export-api-code": "AR_RCL03",
      "excelExport": _vm.arClient.api_ExcelAR_RCL03,
      "columns": _vm.columns,
      "actions": _vm.actions,
      "dataSource": _vm.arClient.api_AR_RCL01
    },
    on: {
      "action-1": function (data) {
        _vm.fetchDetailTravelAgent({
          TravelAgent: {
            Id: data.data.Id
          }
        });
      },
      "action-2": function (data) {
        _vm.$router.push(("/list-account/" + (data.data.Id)));
      }
    },
    scopedSlots: _vm._u([{
      key: "toolbar",
      fn: function () {
        return [_c('PermissionButton', {
          attrs: {
            "api-code": _vm.AR_ICL01,
            "variant": "outline-primary"
          },
          on: {
            "click": function ($event) {
              _vm.isShowModal = true;
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("ar_common_add_new")) + " ")])];
      },
      proxy: true
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }